import { useQuery, UseQueryResult } from 'react-query';

import { ApiHealthCheck, healthCheck } from '../gateway/v1/healthCheck';

const useHealthCheck = (
  moboUserId = 'me',
  enabled?: boolean,
): UseQueryResult<ApiHealthCheck, unknown> =>
  useQuery(['health_checks', moboUserId], () => healthCheck(), {
    cacheTime: 1000 * 60,
    staleTime: 1000 * 60,
    enabled,
  });

export default useHealthCheck;
